<template>
  <entrance />
</template>

<script>
// import HelloWorld from '../components/HelloWorld.vue';
import Entrance from '../components/Entry/Entrance.vue';

export default {
  components: {
    Entrance,
  },
};
</script>
